
import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { LoginModel } from './login-model';

@Injectable({
  providedIn: 'root'
})

export class LoginReactiveService {
  // tslint:disable-next-line: variable-name
  login_form: UntypedFormGroup;

  constructor(
    // tslint:disable-next-line: variable-name
    public _formBuilder: UntypedFormBuilder,
    public loginModel: LoginModel
  ) { }

  loginForm(data: any): void {
    this.login_form = this.login_form ?? this._formBuilder.group(this.loginModel.mapDataToModel(data));
  }
}
